import React from "react";
import { Grid } from "@material-ui/core";
import { Topbar } from "@components";

type Props = {
  children?: React.ReactNode;
};

export function BasicProfileLayout(props: Props) {
  return (
    <Grid container spacing={2} style={{ padding: 16, marginTop: -16 }}>
      <Grid item xs={12}>
        <Topbar />
        {props.children}
      </Grid>
    </Grid>
  );
}
